import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { DownloadSvg } from './svgs';

export const IconDownload: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={DownloadSvg} viewBox="0 0 24 24" {...props} />;
};
